import { render, staticRenderFns } from "./TableData.vue?vue&type=template&id=e9d3dbfe&scoped=true&"
import script from "./TableData.vue?vue&type=script&lang=js&"
export * from "./TableData.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/figma.css?vue&type=style&index=0&id=e9d3dbfe&scoped=true&lang=css&"
import style1 from "./TableData.vue?vue&type=style&index=1&id=e9d3dbfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9d3dbfe",
  null
  
)

export default component.exports